import Grid from '@mui/material/Grid';
import { HighlightedPhrase } from '@openx/components-core/lib/HighlightedPhrase/HighlightedPhrase.tsx';
import type { JSX } from 'react';
import { StyledDetails } from './RowDescription.styled.tsx';

export const RowDescription = ({ description, phrase }): JSX.Element => {
  return (
    <Grid container>
      <StyledDetails data-test="description">
        <HighlightedPhrase searchPhrase={phrase}>{description}</HighlightedPhrase>
      </StyledDetails>
    </Grid>
  );
};
